import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import StatementsPage from "components/pages/StatementsPage";
import Classes from "model";
import { useEffect } from "react";

export default function CaptureEStatementsSearch(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

    return <StatementsPage />
}